module.exports = __webpack_public_path__ + "static/img/phtone1.ed412df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phtone1.png
// module id = I8Yz
// module chunks = 1